import { MsisdnListInterfaceState, initialMsisdnListState } from '../state/msisdn-list.state';
import { MsidnListActions, EMsidnListActions } from '../actions/msidn-list.actions';

export function msisdnListReducer(state: MsisdnListInterfaceState = initialMsisdnListState, action: MsidnListActions): MsisdnListInterfaceState {
  switch (action.type) {
    case EMsidnListActions.GetMsisdnListSuccess: {
      return { ...state, list: action.payload };
    }

    default:
      return state;
  }
};
